export enum ItemType {
    Passive = 'PASSIVE',
    Upgradeable = 'UPGRADEABLE',
    Consumable = 'CONSUMABLE',
}
export interface IUpgrade {
    name: string
    description: string
    imgUrl: string
    priceUpgrade?: number
}

export interface IInventoryItem {
    type: ItemType
    upgrades: Record<string, IUpgrade>
    price: number
    hitsDuration?: number
}
export type Inventory = Record<string, IInventoryItem>

export enum InventoryItemsName {
    AidKit = 'AID_KIT',
    Box50 = 'BOX_50',
    Box100 = 'BOX_100',
    Box200 = 'BOX_200',
    OviFlex100 = 'OVI_FLEX_100',
    EmptyNet10 = 'EMPTY_NET_10',
    EmptyNet25 = 'EMPTY_NET_25',
    StartPack = 'START_PACK',
}


export type InventoryLimit = Record<string, InventoryLimitItem>;

export interface InventoryLimitItem {
    limit: number
}
